import React, { useEffect, useState } from "react";
import styled, { withTheme } from "styled-components/macro";
import { getOrgwebsiteAction } from '_redux/actions/appActions';
import { Alert } from "@material-ui/lab";
import {
  Grid,
  AppBar as MuiAppBar,
  Typography,
  Toolbar,
  Container,
} from "@material-ui/core";


import UserDropdown from "./UserDropdown";
import { useDispatch, useSelector } from "react-redux";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const SmallHeaderLogo = styled.img`
  width: 100px;
`;

const AppBarComponent = ({ onDrawerToggle }) => {
  const dispatch = useDispatch();
  const { organizationWebsite, error } = useSelector(state => state.appReducer);
  const [width, setWidth] = useState((organizationWebsite !== undefined && organizationWebsite.title || "").length * 25 + 10);

  useEffect(() => {
    const loadData = async () => {
      await dispatch(getOrgwebsiteAction());
    };

    loadData();
  }, []);

  if (organizationWebsite === undefined || organizationWebsite === null) {
    return <>
    </>;
  }

  return (
    <>
      {error && <Alert mt={2} mb={1} severity="warning">
        {error.toString()}
      </Alert>}

      <AppBar position="sticky" elevation={0} style={{ background: organizationWebsite.home?.colors.header_background }}>
        <Toolbar>
          <Container maxWidth="lg">
            <Grid container alignItems="center" justifyContent="center">
              {organizationWebsite.logo ? (<>
                <Grid item>
                  <SmallHeaderLogo src={organizationWebsite.logo} />
                </Grid>
                <Grid item>
                  <Typography component="span" variant="span" align="center" gutterBottom style={{
                    width, margin: 10,
                    color: organizationWebsite.home?.colors.header_color,
                  }}>
                    {organizationWebsite.title}
                  </Typography>
                </Grid></>)
                : (
                  <Grid item>
                    <Typography component="span" variant="span" align="center" gutterBottom style={{
                      width, margin: 10,
                      color: organizationWebsite.home?.colors.header_color,
                    }}>
                      {organizationWebsite.title}
                    </Typography>
                  </Grid>
                )}
              <Grid item xs />
              <Grid item>
                <UserDropdown />
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default withTheme(AppBarComponent);
